// extracted by mini-css-extract-plugin
export default {"errorPage":"error404_errorPage__bLK3c","error404":"error404_error404__0T5KS"};